import { useEffect } from 'react'
import { type FormContextValues } from 'react-hook-form'
import { type CollectionsFormData } from 'domains/collections/components/collections-form/utils/collectionsForm.types'

interface UseCollectionsFormCustomValidationProps {
  register: FormContextValues<CollectionsFormData>['register']
  getValues: FormContextValues<CollectionsFormData>['getValues']
}

export const useCollectionsFormCustomValidation = ({
  register,
  getValues,
}: UseCollectionsFormCustomValidationProps) => {
  // validate that a collection cannot not have both a parent and children
  useEffect(() => {
    register('validation.treeStructure', {
      validate: () => {
        const parentId = getValues('details.parentId') as string
        const childrenIds = getValues('childrenIds') || ([] as string[])

        return !(parentId !== '0' && parentId !== '' && childrenIds.length > 0)
      },
    })
  }, [register, getValues])
}
